import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hackerrank': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M477.5 128c14.5 25 14.5 230.9 0 256s-192.4 128-221.3 128c-28.9 0-206.8-102.8-221.3-128s-14.4-230.8 0-256 192.4-128 221.3-128 206.8 103 221.3 128zM316.1 414.2c4 0 40.4-35.8 37.6-38.7-0.9-0.8-8.8-1.5-17.7-1.8 0-32.4-3-19.1 0.7-210.3 0.1-3.7-1-5.4-4.5-5.4-11.1-0.1-22.2 0-33.2 0.1-3.3 0-4.3 1.8-4.2 5.2 1.6 48.9 1.2 79.1 1.2 83.6h-80.3c0.6-25.8 0.2-79.6 2.6-105.4v-3.2c8.9-0.4 15.9-1 16.8-1.8 2.9-2.9-34.3-38.7-38.3-38.7-3.9 0-41.4 35.8-38.5 38.7 0.9 0.8 7.6 1.5 17.3 1.8v3.2c3.2 128.7 1.1 179.2 0.2 212.7-0.1 4.6 1.6 6.1 5.7 6.1 10.1 0 20.3 0.1 30.4 0.1 4.2 0.1 6-1.4 5.7-5.9-1.8-36.7-1.4-65.8-1.4-72.9h79.9c0 2.4 0.4 3.8 0.4 5.8-0.4 17.7-0.9 60.1-0.9 86.3-11.3 0.3-16.7 1-17.5 1.8-2.9 2.9 34 38.7 38 38.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hackerrank.js
// module id = 879
// module chunks = 0